import { render, staticRenderFns } from "./MagneticButton.vue?vue&type=template&id=0cae86e7"
import script from "./MagneticButton.vue?vue&type=script&lang=js"
export * from "./MagneticButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports